export default "__VITE_ASSET__DXmgvwc8__"